import { createFileRoute } from "@tanstack/react-router";
import { TutorCabinetPage } from "@/components/partners/TutorCabinetPage";
import { tutorCabinetHead } from "@/components/partners/tutor-cabinet-head";

// Кабинет репетитора (ru): вход по ссылке из письма, правка анкеты, пауза, удаление.
// noindex, в sitemap нет (src/lib/partner-cabinet.ts).
export const Route = createFileRoute("/ru/tutors/me")({
  head: () => tutorCabinetHead("ru"),
  component: () => <TutorCabinetPage lang="ru" />,
});
